import { NODE_TYPES } from './doc-editor';

export const HOTKEYS = [
    {
        action: 'undo',
        keyCode: 90,
        modKey: true
    },
    {
        action: 'redo',
        keyCode: 89,
        modKey: true
    },
    {
        type: NODE_TYPES.headingOne,
        modKey: true,
        altKey: true,
        keyCode: 49 // 1
    },
    {
        type: NODE_TYPES.headingTwo,
        modKey: true,
        altKey: true,
        keyCode: 50 // 2
    },
    {
        type: NODE_TYPES.headingThree,
        modKey: true,
        altKey: true,
        keyCode: 51 // 3
    },
    {
        type: NODE_TYPES.lineSeparator,
        modKey: true,
        altKey: true,
        keyCode: 83 // S
    },
    {
        type: NODE_TYPES.table,
        modKey: true,
        altKey: true,
        keyCode: 84 // T
    },
    {
        type: NODE_TYPES.orderedList,
        modKey: true,
        shiftKey: true,
        keyCode: 76 // L
    },
    {
        type: NODE_TYPES.unorderedList,
        modKey: true,
        keyCode: 76 // L
    },
    {
        type: NODE_TYPES.blockQuote,
        modKey: true,
        shiftKey: true,
        keyCode: 85 // U
    },
    {
        type: NODE_TYPES.checklistItem,
        modKey: true,
        shiftKey: true,
        keyCode: 79 // O
    },
    {
        type: NODE_TYPES.checklistItem,
        modKey: true,
        shiftKey: true,
        keyCode: 68 // D
    },
    {
        type: NODE_TYPES.codeBlock,
        altKey: true,
        modKey: true,
        shiftKey: true,
        keyCode: 67 // C
    },
    {
        type: NODE_TYPES.code,
        modKey: true,
        shiftKey: true,
        keyCode: 67 // C
    },
    {
        type: NODE_TYPES.bold,
        modKey: true,
        keyCode: 66 // B
    },
    {
        type: NODE_TYPES.italic,
        modKey: true,
        keyCode: 73 // I
    },
    {
        type: NODE_TYPES.underline,
        modKey: true,
        keyCode: 85 // U
    },
    {
        type: NODE_TYPES.strikethrough,
        modKey: true,
        keyCode: 69 // E
    }
];


export const matchHotKey = event => {
    const hotKey = HOTKEYS.find(hotKey => {
        if (event.keyCode !== hotKey.keyCode) {
            return false;
        }

        if (hotKey.modKey && !(event.metaKey || event.ctrlKey)) {
            return false;
        }

        if (hotKey.altKey && !event.altKey) {
            return false;
        }

        if (hotKey.shiftKey && !event.shiftKey) {
            return false;
        }

        return true;
    });

    if (!hotKey) {
        return false;
    }

    return hotKey;
}

export const getHotkeyByType = type => HOTKEYS.find(hotKey => hotKey.type === type);
